<template>
  <div>
    <b-tabs v-model="companyTab" align="center">
      <b-tab>
        <template #title>
          <feather-icon icon="LayersIcon" />
          <span style="font-size: 13px">USPS</span>
        </template>
        <div class="p-2">
          <div class="input-group col-8 gap-5 abc flex-column">
            <div class="row mb-1">
              <b-form-radio
                v-model="shippingStatus"
                plain
                name="accountTypeoptions"
                value="destination"
              >
                <h5 class="font-bold">
                  {{ $t("usps.choose_only_destination") }}
                </h5>
              </b-form-radio>
              <b-form-radio
                v-model="shippingStatus"
                plain
                name="accountTypeoptions"
                value="shipped"
                class="ml-2"
              >
                <h5 class="font-bold">
                  {{ $t("usps.choose_shipped_from_state") }}
                </h5>
              </b-form-radio>
              <b-form-radio
                v-model="shippingStatus"
                plain
                name="accountTypeoptions"
                value="city"
                class="ml-2"
              >
                <h5 class="font-bold">
                  {{ $t("usps.choose_shipped_from_city") }}
                </h5>
              </b-form-radio>
            </div>
            <div class="row w-cus">
              <div class="position-relative mr-1" style="width: 20rem">
                <span class="input-label font-bold">{{
                  $t("usps.shipping_date_from")
                }}</span>
                <div>
                  <flat-pickr
                    v-model="shippingDateFrom"
                    class="form-control invoice-edit-input invoice-input-top mt-1"
                    :placeholder="fourDaysBeforeCurrentDate"
                    :class="{ 'is-invalid': shippingDateFromInvalid }"
                  />
                  <feather-icon
                    v-if="shippingDateFrom === ''"
                    size="16"
                    icon="CalendarIcon"
                    class="cursor-pointer clear-all mt-us"
                  />
                  <feather-icon
                    v-else-if="!shippingDateFromInvalid"
                    size="16"
                    icon="XIcon"
                    class="cursor-pointer clear-all mt-us"
                    @click="shippingDateFrom = ''"
                  />
                </div>
                <div v-if="shippingDateFromInvalid" class="invalid-feedback">
                  Shipping Date From must be less than Shipping Date To.
                </div>
              </div>

              <div class="position-relative mr-1" style="width: 20rem">
                <span class="input-label font-bold">{{
                  $t("usps.shipping_date_to")
                }}</span>
                <div>
                  <flat-pickr
                    v-model="shippingDateTo"
                    class="form-control invoice-edit-input invoice-input-top mt-1"
                    :placeholder="currentDate"
                    :class="{ 'is-invalid': shippingDateToInvalid }"
                  />
                  <feather-icon
                    v-if="shippingDateTo === ''"
                    size="16"
                    icon="CalendarIcon"
                    class="cursor-pointer clear-all mt-us"
                  />
                  <feather-icon
                    v-else-if="!shippingDateFromInvalid"
                    size="16"
                    icon="XIcon"
                    class="cursor-pointer clear-all mt-us"
                    @click="shippingDateTo = ''"
                  />
                </div>
                <div v-if="shippingDateToInvalid" class="invalid-feedback">
                  Shipping Date From must be less than Shipping Date To.
                </div>
              </div>

              <div
                class="position-relative mr-1 py-usps-uk"
                style="width: 20rem"
              >
                <span class="input-label font-bold">{{
                  $t("usps.delievered_after")
                }}</span>
                <div>
                  <flat-pickr
                    v-model="deliveredBy"
                    class="form-control invoice-edit-input invoice-input-top mt-1"
                    :placeholder="currentDate"
                  />
                  <feather-icon
                    v-if="deliveredBy === ''"
                    size="16"
                    icon="CalendarIcon"
                    class="cursor-pointer clear-all mtups-us"
                  />
                  <feather-icon
                    v-else
                    size="16"
                    icon="XIcon"
                    class="cursor-pointer clear-all mtups-us"
                    @click="deliveredBy = ''"
                  />
                </div>
              </div>

              <div
                v-if="shippingStatus === 'city'"
                class="mr-1 pt-2"
                style="width: 20rem"
              >
                <span class="input-label font-bold">{{
                  $t("usps.shipping_city")
                }}</span>

                <input
                  v-model="shipping_city"
                  type="text"
                  :placeholder="$t('usps.city')"
                  @input="trimShippingCity"
                  class="search-product form-control mt-1"
                />
                <div
                  v-if="isShippingCityOnlySpaces && shipping_city"
                  class="text-danger mt-1"
                >
                  {{
                    $t("usps.shipping_city") +
                    " " +
                    $t("usps.no_spaces_allowed")
                  }}
                </div>
                <!-- @keyup="searchCompanies()" -->
              </div>
              <div
                v-if="shippingStatus === 'shipped'"
                class="pt-2 mr-1"
                style="width: 20rem"
              >
                <span class="input-label font-bold">{{
                  $t("usps.shipping_state")
                }}</span>
                <select
                  v-model="shipping_state"
                  id="state"
                  :disabled="isDisabled"
                  :placeholder="$t('usps.state')"
                  class="search-product form-control mt-1"
                >
                  <option v-if="!isDisabled" value="" selected>
                    Select a state
                  </option>
                  <option
                    v-for="option in options"
                    :key="option.key"
                    :value="option.key"
                    selected
                  >
                    {{ option.value }}
                  </option>
                </select>
              </div>

              <div
                v-if="shippingStatus === 'city'"
                class="mr-1 pt-2"
                style="width: 20rem"
              >
                <span class="input-label font-bold">{{
                  $t("usps.destination_city")
                }}</span>

                <input
                  v-model="destination_city"
                  type="text"
                  :placeholder="$t('usps.city')"
                  @input="trimCityState"
                  class="search-product form-control mt-1"
                />
                <div
                  v-if="isCityStateOnlySpaces && destination_city"
                  class="text-danger mt-1"
                >
                  {{
                    $t("usps.destination_city") +
                    " " +
                    $t("usps.no_spaces_allowed")
                  }}
                </div>
              </div>

              <div
                v-if="
                  shippingStatus === 'destination' ||
                  shippingStatus === 'shipped'
                "
                class="mr-1 pt-2"
                style="width: 20rem"
              >
                <span class="input-label font-bold">{{
                  $t("usps.destination_zip")
                }}</span>
                <input
                  v-model="zipCode"
                  type="number"
                  :placeholder="$t('usps.zipCode')"
                  class="search-product form-control mt-1"
                  @input="validateZipCode"
                />
                <span v-if="zipCodeError" class="text-danger">{{
                  zipCodeError
                }}</span>
              </div>

              <div class="d-flex">
                <b-form-checkbox
                  v-model="show_deliverable"
                  class="custom-control-primary custom-switch-btn mt-4"
                  name="invoiceData.scheduled"
                  :check-status="false"
                >
                  <span class="ml-1 input-label font-bold">
                    {{ $t("usps.show_deleverable") }}</span
                  >
                </b-form-checkbox>
              </div>

              <div style="width: 20rem" class="text-center" />
            </div>
          </div>
          <b-button
            variant="primary"
            class="float-left mt-2 mb-1 text-capitalize"
            style="margin-right: 15px; height: fit-content"
            :disabled="isButtonDisabled()"
            @click="handleClick"
          >
            <div
              v-if="isLoading"
              class="spinner-border d-flex align-items-center"
              style="height: 16px; width: 16px"
            />
            <div v-else class="">
              <feather-icon
                icon="FilterIcon"
                size="17"
                class="cursor-pointer"
              />
              <span>{{ $t("usps.apply_filters") }}</span>
            </div>
          </b-button>
        </div>

        <div v-if="no_record_found" class="mt-5">
          <div
            class="d-flex flex-direction-column align-items-center justify-content-center"
          >
            <div class="align-items-center justify-content-center">
              <div class="mb-1 start-chat-icon pl-3">
                <feather-icon icon="FolderIcon" size="40" />
              </div>
              <h5 class="sidebar-toggle start-chat-text">
                {{ $t("usps.no_carrier") }}
              </h5>
            </div>
          </div>
        </div>

        <b-table
          v-if="
            shippignItems.length || destinationItems.length || cityItems.length
          "
          :fields="shippingfields"
          :items="
            shippingStatus === 'shipped'
              ? shippignItems
              : shippingStatus === 'destination'
              ? destinationItems
              : cityItems
          "
          responsive
          class="mb-0"
          show-empty
          :empty-text="'no records found'"
          empty-filtered-text
        >
          <template>
            <div class="d-flex align-items-center justify-content-center">
              <div class="mb-1 start-chat-icon">
                <feather-icon icon="FolderIcon" size="40" />
              </div>
              <h5 class="sidebar-toggle start-chat-text">no_record</h5>
            </div>
          </template>

          <template #cell(trackingNumber)="data">
            <div class="d-flex flex-column">
              <span v-if="!trackerNumber[data.item.encode]" class="font-bold">{{
                data.item.trackingNumber
              }}</span>
              <feather-icon
                v-if="!trackerNumber[data.item.encode]"
                icon="EyeIcon"
                size="16"
                class="mt-1 cursor-pointer"
                @click="handleEyeClick(data.item)"
              >
                {{ trackerNumber[data.item.encode] }}
                {{ !trackerNumber[data.item.encode] }}
              </feather-icon>
              <!-- :id="'tooltip-button-' + data.item.encode" -->
              <!-- <b-tooltip
                :target="'tooltip-button-' + data.item.encode"
                placement="top"
                triggers="hover"
              >
                show
              </b-tooltip> -->
              <a
                v-if="trackerNumber[data.item.encode]"
                class="cursor-pointer font-bold"
                target="_blank"
                :href="`https://tools.usps.com/go/TrackConfirmAction?tLabels=${
                  trackerNumber[data.item.encode]
                }`"
                >{{ trackerNumber[data.item.encode] }}</a
              >
              <CopyToClipboard
                ref="copyToClipboardRef"
                :key="trackerNumber[data.item.encode]"
                class="cursor-pointer"
                :text="'trackerNumber[data.item.encode]'"
                @copy="copyAffiliateLink(trackerNumber[data.item.encode])"
              >
                <feather-icon
                  v-if="trackerNumber[data.item.encode]"
                  class="mt-1 cursor-pointer"
                  :icon="
                    copied[data.item.trackingNumber] ? 'CheckIcon' : 'CopyIcon'
                  "
                  size="14"
                />
              </CopyToClipboard>
            </div>
          </template>

          <template #cell(trackingStatus)="data">
            <div class="font-bold">{{ data.item.trackingStatus }}</div>
          </template>

          <template #cell(shippingDate)="data">
            <div class="font-bold">
              {{
                new Date(data.item.shippingDate).toLocaleString("en-US", {
                  dateStyle: "medium",
                  timeStyle: "short",
                })
              }}
            </div>
          </template>

          <template #cell(deliveryDate)="data">
            <div class="font-bold">
              {{
                new Date(data.item.deliveryDate).toLocaleString("en-US", {
                  dateStyle: "medium",
                  timeStyle: "short",
                })
              }}
            </div>
          </template>
        </b-table>
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="BookOpenIcon" />
          <span style="font-size: 13px">UPS</span>
        </template>
        <ups />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="LayersIcon" />
          <span style="font-size: 13px">FEDEX</span>
        </template>
        <fedex />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import CopyToClipboard from "vue-copy-to-clipboard";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BProgress,
  BModal,
  BCardText,
  BTabs,
  BTab,
  BFormCheckbox,
  BFormRadio,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import useJwt from "@/auth/jwt/useJwt";
import axios from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import fedex from "./fedex.vue";
import ups from "./ups.vue";
import { stateOptions } from "./../../utils/states.js";
export default {
  components: {
    BCardCode,
    BTable,
    BProgress,
    BBadge,
    BButton,
    BLink,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BModal,
    BCardText,
    BTabs,
    BTab,
    ups,
    flatPickr,
    BFormCheckbox,
    BFormRadio,
    CopyToClipboard,
    fedex,
    stateOptions,
  },

  data() {
    return {
      companyToDelete: "",
      deleteModalShow: false,
      direction: "asc",
      sortField: "companyName",
      sortBy: "companyName",
      sortDesc: false,
      shippingDateFrom: "",
      shippingDateTo: "",
      deliveredBy: "",
      shipping_city: "",
      shipping_state: "",
      zipCode: "",
      options: stateOptions,
      show_deliverable: false,
      near_by_zip: false,
      shippingStatus: "destination",
      fields: [
        // A virtual column that doesn't exist in items
        "Country",
        // A column that needs custom formatting
        {
          key: "companyName",
          label: "Company Name",
          sortable: true,
        },
        {
          key: "platform",
          label: "Platform",
          sortable: true,
        },
        {
          key: "companyMail",
          label: "Email",
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
        },
        // A regular column
        {
          key: "companyOwnerFirstName",
          label: "Agent Name ",
          sortable: true,
        },
        // A regular column
        {
          key: "companyIdentificationNumber",
          label: "Company ID",
          sortable: true,
        },
        // A virtual column made up from two fields
        {
          key: "action",
          label: "Action",
        },
      ],
      items: [],
      currentPage: 1,
      perPage: "10",
      totalRecords: "",
      totalPages: "",
      searchQuery: "",
      companyTab: 0,
      unverifiedCompanies: [],
      shippingfields: [
        {
          key: "trackingNumber",
          label: "Tracking Number",
          // sortable: true,
        },
        {
          key: "trackingStatus",
          label: "Status",
          sortable: true,
        },
        {
          key: "shippingDate",
          label: "Shipping Date",
          // sortable: true,
        },
        {
          key: "shippingCity",
          label: "Shipping City",
          // sortable: true,
        },
        {
          key: "shippingState",
          label: "Shipping State",
          // sortable: true,
        },
        {
          key: "deliveryDate",
          label: "Delivery Date",
          // sortable: true,
        },
        {
          key: "deliveryCity",
          label: "Delivery City",
          // sortable: true,
        },
        {
          key: "deliveryState",
          label: "Delivery State",
          // sortable: true,
        },
        {
          key: "zipCode",
          label: "Zipcode",
          // sortable: true,
        },
        {
          key: "weight",
          label: "Weight (kg)",
          // sortable: true,
        },
      ],
      shippignItems: [],
      isLoading: false,
      trackerNumber: "",
      copied: {}, // Track copied state
      destinationItems: [],
      cityItems: [],
      zipCodeError: "",
      destination_city: "",
      no_record_found: false,
      trimmedCityState: "",
      trimmedShippingCity: "",
      userDetail: {},
      isDisabled: false,
    };
  },
  computed: {
    shippingDateFromInvalid() {
      return (
        this.shippingDateFrom &&
        this.shippingDateTo &&
        new Date(this.shippingDateFrom) >= new Date(this.shippingDateTo)
      );
    },
    shippingDateToInvalid() {
      return (
        this.shippingDateFrom &&
        this.shippingDateTo &&
        new Date(this.shippingDateFrom) >= new Date(this.shippingDateTo)
      );
    },
    currentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    fourDaysBeforeCurrentDate() {
      const date = new Date();
      date.setDate(date.getDate() - 4);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    isCityStateOnlySpaces() {
      return (
        this.destination_city.trim() === "" ||
        /^[\s]+[A-Za-z]/.test(this.destination_city)
      );
    },
    isShippingCityOnlySpaces() {
      return (
        this.shipping_city.trim() === "" ||
        /^[\s]+[A-Za-z]/.test(this.shipping_city)
      );
    },
  },
  mounted() {
    // Set the default value for deliveredBy to ten days before the current date
    this.shippingDateFrom = this.fourDaysBeforeCurrentDate;
    this.shippingDateTo = this.currentDate;
    this.deliveredBy = this.currentDate;
    this.getUserDetail();
  },
  // created() {
  //   this.getAllCompanies();
  //   this.getUnverifiedCompanies();
  // },
  watch: {
    // shippingStatus() {
    //   this.zipCode = "";
    //   this.shipping_city = "";
    //   this.shipping_state = "";
    //   this.destination_city = "";
    //   this.zipCodeError = "";
    // },
    shippingDateTo(newDate) {
      if (newDate !== this.deliveredBy) {
        this.deliveredBy = newDate;
      }
    },
  },
  methods: {
    async getUserDetail() {
      try {
        const data = await axios.get("account/api/user/who-am-i");
        if (data.data) {
          this.userDetail = data.data;
          if (this.userDetail.shippingStates.length > 0) {
            const data1 = this.userDetail.shippingStates
              .map((item) => ({
                key: item,
                value: this.userDetail.shippingStates.join(", "),
              }))
              .filter(
                (item, index, self) =>
                  index === self.findIndex((t) => t.value === item.value)
              );
            this.isDisabled = true;
            this.options = data1;
            if (this.options.length > 0) {
              this.shipping_state = this.options[0].key; // Set the default value to the first option's key
            }
          }
        }
      } catch (error) {
        console.log("error", error);
        this.isDisabled = false;
      }
    },
    isButtonDisabled() {
      if (this.shippingStatus === "shipped") {
        return (
          !this.shippingDateFrom ||
          !this.shippingDateTo ||
          !this.deliveredBy ||
          this.shipping_state === "" ||
          !this.zipCode ||
          this.zipCodeError ||
          // (!this.shipping_city && !this.destination_city) ||
          // (this.isCityStateOnlySpaces && this.destination_city) ||
          // (this.isShippingCityOnlySpaces && this.shipping_city) ||
          this.isLoading
        );
      } else if (this.shippingStatus === "destination") {
        return (
          !this.shippingDateFrom ||
          !this.shippingDateTo ||
          !this.deliveredBy ||
          !this.zipCode ||
          this.zipCodeError ||
          this.isLoading
        );
      } else if (this.shippingStatus === "city") {
        return (
          !this.shippingDateFrom ||
          !this.shippingDateTo ||
          !this.deliveredBy ||
          !this.shipping_city ||
          !this.destination_city ||
          this.isLoading
        );
      }
      return true;
    },
    trimCityState() {
      this.trimmedCityState = this.destination_city.trim();
    },
    trimShippingCity() {
      this.trimmedShippingCity = this.shipping_city.trim();
    },
    validateZipCode() {
      if (this.zipCode.length > 5) {
        this.zipCode = this.zipCode.slice(0, 5);
      }
      if (this.zipCode.length < 5) {
        this.zipCodeError = "ZIP Code must be exactly 5 digits long.";
      } else {
        this.zipCodeError = "";
      }
    },
    toUpperCase(event) {
      this.shipping_state = event.target.value
        .replace(/[^A-Za-z]/g, "")
        .toUpperCase();
    },
    handleEyeClick(e) {
      const ipAddress = localStorage.getItem("ip") || "";
      let payload = {};
      if (this.shippingStatus === "shipped") {
        payload = {
          searchId: e.searchId,
          number: Number(e.encode),
          ipAddress: ipAddress,
          shippingState: true,
        };
      } else {
        payload = {
          searchId: e.searchId,
          number: Number(e.encode),
          ipAddress: ipAddress,
        };
      }

      const token = useJwt.getToken();
      useJwt
        .DecodeNumber(token, payload)
        .then((response) => {
          const trackingNumber = Object.values(response.data)[0]; // Extracting the value from the response
          this.trackerNumber = {
            ...this.trackerNumber,
            [e.encode]: trackingNumber,
          };
          this.copyAffiliateLink(trackingNumber);
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },

    copyAffiliateLink(trackingNumber) {
      navigator.clipboard.writeText(trackingNumber);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Tracking Number Successfully Copied",
          icon: "CheckIcon",
          variant: "success",
        },
      });
      setTimeout(() => {
        this.$set(this.copied, trackingNumber, false);
      }, 2000); // Show the check icon for 2 seconds
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const year = d.getFullYear();

      return `${month}/${day}/${year}`;
    },
    async handleClick() {
      const ipAddress = localStorage.getItem("ip") || "";
      // USPSByShippingState
      this.isLoading = true;
      if (this.shippingStatus === "shipped") {
        if (this.shipping_state === "") {
          const data1 = {
            shippingDateFrom: this.formatDate(this.shippingDateFrom),
            shippingDateTo: this.formatDate(this.shippingDateTo),
            deliveredBy: this.formatDate(this.deliveredBy),
            // shippingCities: [this.shipping_city],
            showDelivered: this.show_deliverable,
            carrier: "usps",
            city: this.destination_city,
            // zipCode: this.zipCode,
            // showNearbyZip: this.near_by_zip,
          };
          try {
            const token = useJwt.getToken();
            const response = await useJwt.USPSByShippingCities(token, data1);
            this.isLoading = false;
            if (response.data.elements !== "") {
              if (response.data.totalElements === 0) {
                this.no_record_found = true;
                this.shippignItems = [];
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: `No Record Found. Please Try another Date Range`,
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } else {
                this.no_record_found = false;
                this.shippignItems = response.data.elements;
              }
            }
          } catch (error) {
            this.isLoading = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `${error.response.data.errorMessage}`,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        } else {
          const data1 = {
            shippingDateFrom: this.formatDate(this.shippingDateFrom),
            shippingDateTo: this.formatDate(this.shippingDateTo),
            deliveredBy: this.formatDate(this.deliveredBy),
            // shippingCities: [this.shipping_city],
            showDelivered: this.show_deliverable,
            carrier: "usps",
            // city: this.destination_city,
            shippingState: this.shipping_state,
            zipCode: this.zipCode,
            // showNearbyZip: this.near_by_zip,
          };
          try {
            const token = useJwt.getToken();
            const response = await useJwt.USPSByShippingState(token, data1);
            this.isLoading = false;
            if (response.data.elements !== "") {
              if (response.data.totalElements === 0) {
                this.no_record_found = true;
                this.shippignItems = [];
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: `No Record Found. Please Try another Date Range`,
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } else {
                this.no_record_found = false;
                this.shippignItems = response.data.elements;
              }
            }
          } catch (error) {
            this.isLoading = false;
            console.log("error..", error.error);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `${error.response.data.errorMessage}`,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        }
      }

      if (this.shippingStatus === "destination") {
        const data1 = {
          shippingDateFrom: this.formatDate(this.shippingDateFrom),
          shippingDateTo: this.formatDate(this.shippingDateTo),
          deliveredBy: this.formatDate(this.deliveredBy),
          shippingState: this.shipping_state,
          showDelivered: this.show_deliverable,
          carrier: "usps",
          zipCode: this.zipCode,
          // showNearbyZip: this.near_by_zip,
        };
        try {
          const token = useJwt.getToken();
          const response = await useJwt.getUSPSRecordsByZip(token, data1);
          this.isLoading = false;
          if (response.data.elements !== "") {
            if (response.data.totalElements === 0) {
              this.no_record_found = true;
              this.destinationItems = [];
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `No Record Found. Please Try another Date Range`,
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              this.no_record_found = false;
              this.destinationItems = response.data.elements;
            }
          }
        } catch (error) {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }

      if (this.shippingStatus === "city") {
        const data1 = {
          shippingDateFrom: this.formatDate(this.shippingDateFrom),
          shippingDateTo: this.formatDate(this.shippingDateTo),
          deliveredBy: this.formatDate(this.deliveredBy),
          shippingCities: [this.shipping_city],
          city: this.destination_city,
          showDelivered: this.show_deliverable,
          carrier: "usps",
          // zipCode: this.zipCode,
          // showNearbyZip: this.near_by_zip,
        };
        try {
          const token = useJwt.getToken();
          const response = await useJwt.USPSByShippingCities(token, data1);
          this.isLoading = false;
          if (response.data.elements !== "") {
            if (response.data.totalElements === 0) {
              this.no_record_found = true;
              this.cityItems = [];
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `No Record Found. Please Try another Date Range`,
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              this.no_record_found = false;
              this.cityItems = response.data.elements;
            }
          }
        } catch (error) {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },
  },
};
</script>
<style lang="scss">
/*  */
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.input-group {
  box-shadow: none !important;
}

.mt-1 {
  margin-top: 4px !important;
}
.mt-2 {
  // margin-top: -8px !important;
}

.input-label {
  font-weight: 500;
}

.mt-us {
  margin-top: 10px;
}

.mtups-us {
  margin-top: 14px !important;
}

.py-usps-uk {
  padding: 0 0 0 0 !important;
}

.font-bold {
  font-weight: 600;
}

.w-cus {
  max-width: 1040px;
}
@media (max-width: 1652px) {
  .py-usps-uk {
    padding: 1.5rem 0 0 0 !important;
  }
  .mtups-us {
    margin-top: 20px !important;
  }
}

@media (min-width: 576px) {
  .modal-dialog {
    margin: 15rem auto auto auto !important;
  }
}
</style>
